module.exports = __webpack_public_path__ + "media/images/logos/rowhouse-logo-bf0a5601f60376de5da15365c078f787.svg";